import React from 'react';
import './CircularProgress.scss';

export default function CircularProgress() {
  return <progress id="circular-progress" className="pure-material-progress-circular" />;
}
